import { TreeSelect, TreeSelectProps } from "antd";
import useListaRelatoriosPorGrupo from "core/features/relatorios/hooks/useListaRelatoriosPorGrupo";
import React, { useMemo } from "react";
import { Container } from "./styles";
import {
  ListaRelatoriosParams,
  ListaRelatoriosResponse,
} from "core/features/relatorios/typings";
import { DataNode } from "antd/lib/tree";

interface SelectRelatorioTreeProps<T> extends TreeSelectProps<T> {
  errorMessage?: string;
  params?: ListaRelatoriosParams;
}

function getNodes(data: ListaRelatoriosResponse[] | undefined): DataNode[] {
  if (!data) {
    return [];
  }

  return data?.map((item) => ({
    key: item.id,
    disabled: !!item.items?.length,
    children: getNodes(item.items ?? []),
    isLeaf: !item.items?.length,
    title: item.nome,
    disableCheckbox: true,
    pdfUrl: item.pdfUrl,
  }));
}
function SelectRelatorioTree({
  errorMessage,
  params,
  ...props
}: SelectRelatorioTreeProps<any>) {
  const { data, isLoading } = useListaRelatoriosPorGrupo(params);

  const onChange = (
    currentNode: any,
    labelList: React.ReactNode[],
    extra: any
  ) => {
    if (props.onChange !== undefined) {
      props.onChange(currentNode, labelList, extra);
    }
  };

  const nodes = useMemo(() => getNodes(data), [data]);

  return (
    <Container>
      <TreeSelect
        {...props}
        size="large"
        showSearch
        style={{
          width: "100%",
          borderColor: errorMessage ? "red" : "transparent",
          borderWidth: errorMessage ? "1px" : "0px",
          borderStyle: "solid",
        }}
        disabled={isLoading}
        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
        placeholder="Selecione o relatório"
        allowClear
        treeDefaultExpandAll
        loading={isLoading}
        treeData={nodes}
        onChange={onChange}
      />
    </Container>
  );
}

export default SelectRelatorioTree;
